import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { observer } from 'mobx-react-lite';
import classNames from 'classnames';

import {
    PrimaryButton,
    useForm,
    ANALYTICS_ATTRIBUTE_NAME,
    ANALYTICS_KEY,
} from '@ratehub/base-ui';
import {
    RateFetchingOptionsPropType,
    useApplyForRateCallback,
} from '@ratehub/mtg-common';


function PaymentCalculatorLeadFormButton({
    column,
    selectedRate,
    rateFetchingOptions,
    className,
    ...otherProps
}) {
    const form = useForm();
    const applyForRate = useApplyForRateCallback();

    function handleCTAClick(selectedRate, rateFetchingOptions) {
        if (!form.isValid || !selectedRate) {
            return;
        }

        applyForRate({
            rate: selectedRate,
            rateFetchingOptions,
        });
    }

    return (
        <div
            ref={self => self && (self[ANALYTICS_KEY] = selectedRate)}
            className={
                classNames(className,
                    { [ANALYTICS_ATTRIBUTE_NAME]: !!selectedRate },
                )
            }
            {...otherProps}
        >
            <PrimaryButton
                data-name={`scenarios[${column}].mtg-paymentCalculator-getRate-cta`}
                disabled={!selectedRate?.provider}
                type="button"
                message={(
                    <FormattedMessage
                        id="mtg-calculator.PaymentCalculatorInputs.getRateCTA"
                        defaultMessage="Get this rate"
                    />
                )}
                onClick={() =>
                    handleCTAClick(selectedRate, rateFetchingOptions)
                }
            />
        </div>
    );
}

PaymentCalculatorLeadFormButton.propTypes = {
    column: PropTypes.number.isRequired,
    rateFetchingOptions: RateFetchingOptionsPropType.isRequired,
    selectedRate: PropTypes.object,
    className: PropTypes.string,
};

PaymentCalculatorLeadFormButton.defaultProps = {
    selectedRate: {},
    className: undefined,
};

export default observer(PaymentCalculatorLeadFormButton);
